type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "dark" | "light";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  tone = "dark",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "max-w-2xl mx-auto text-center" : "max-w-2xl"}>
      <span
        className={`inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-widest uppercase ${
          tone === "dark" ? "text-accent-600" : "text-accent-300"
        }`}
      >
        <span className="w-6 h-px bg-current inline-block"></span>
        {eyebrow}
      </span>
      <h2
        className={`mt-3 font-heading font-bold text-2xl md:text-4xl leading-snug ${
          tone === "dark" ? "text-foreground-950" : "text-background-50"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            tone === "dark" ? "text-foreground-600" : "text-background-100/80"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}